import { createFileRoute } from "@tanstack/react-router";
import { PortalShell } from "@/components/portal/PortalShell";
import { RoleDashboard } from "@/components/portal/RoleDashboard";

const NAV = [
  { to: "/app/sales", label: "Dashboard" },
  { to: "/app/crm", label: "CRM" },
  { to: "/app/approvals", label: "Freigaben" },
];

export const Route = createFileRoute("/_authenticated/app/sales")({
  ssr: false,
  head: () => ({ meta: [{ title: "Vertriebsportal" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => (
    <PortalShell nav={NAV}>
      <RoleDashboard title="Vertriebsportal" scope="sales" />
    </PortalShell>
  ),
});
